import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FieldHockeyColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon-freeform"
        >
            <g id="Field-Hockey" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path d="M16.104 21.268a2.5 2.5 0 1 1-3.535-3.536 2.5 2.5 0 0 1 3.535 3.536z" fill="#DEDCDA" />
                <path fill="#E69845" d="M15.277 10.528h4.44l-1.56 3h-4.44z" />
                <path
                    d="M15.412 20.552c-.566.578-1.549.578-2.115 0a1.586 1.586 0 0 1 0-2.21 1.471 1.471 0 0 1 2.115 0 1.586 1.586 0 0 1 0 2.21zm-12.369-3.78c-.214-1.64.404-3.503 1.378-4.154.279-.187.738-.385 1.466.034.741.425.697.77.59 1.6-.095.746-.239 1.874.784 2.699.849.687 2.354.914 3.798-.711.176-.2.666-.764 1.346-1.552h3.889c-.413.475-.803.926-1.154 1.334-1.149-.254-2.415.047-3.27.919-.884.9-1.181 2.168-.912 3.325-.887.485-1.862.734-2.967.734-2.795 0-4.597-1.541-4.948-4.228zm15.955-5.186-.963 1.102H14.13l.949-1.102h3.92zM22.65 8.9a.997.997 0 0 0-1.408.105c-.14.164-.312.362-.502.58h-3.944c2.854-3.317 5.73-6.67 5.958-6.933a1 1 0 0 0-1.518-1.303c-.107.124-10.717 12.484-11.675 13.563-.16.18-.71.755-1.044.484-.122-.098-.142-.22-.056-.89.119-.934.319-2.498-1.579-3.59-1.219-.7-2.488-.686-3.574.04-1.62 1.083-2.566 3.638-2.247 6.075C1.54 20.713 4.196 23 7.99 23c1.44 0 2.758-.345 3.942-.995a3.457 3.457 0 0 0 4.907-.053c1.327-1.354 1.345-3.535.07-4.922 1.89-2.191 4.734-5.422 5.85-6.722a.998.998 0 0 0-.11-1.408z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
